import React, {Component} from 'react'
import { withRouter } from 'react-router'
import {connect} from 'react-redux';

class Site extends Component {
  componentDidUpdate(prevProps) {
    const newRoot = this.props.location.pathname.substring(1).split("/",1)[0]
    const oldRoot = prevProps.location.pathname.substring(1).split("/",1)[0]

    if (newRoot === "bestellung" && oldRoot === "shop")
      return;

    if (newRoot === "shop" && oldRoot === "bestellung")
      return;

    if (newRoot !== oldRoot) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const classNames = ["site"];

    if (this.props.loading)
      classNames.push("site-loading")

    return (
        <div className="site">
        {this.props.children}
        </div>
    )
  }
}

export default withRouter(connect(
  (state, props) => {
    return {
      loading: state.site.loading
    }
  },
  (dispatch, props) => {
    return {
      
    }
  }
)(Site))


// WEBPACK FOOTER //
// ./src/components/Site.js